///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/select2.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'


declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ReviewReport/RatingReportSelf.html'
})

export class RatingReportSelfComponent implements OnInit {
    constants: Constants;
    userDetail: any;
    selfuser: boolean = true;
    public showLoader = false;
    public reportItems: any[] = [];
    public reportItemsByReviewer: any[] = [];
    public reviewUsers: any[] = [];
    filter: any = {};
    public reviewers: any[] = [];
    filter1: any = {};

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter = { 'Year': moment().format('YYYY'),'ReviewUser':this.userDetail.SiteUserId};
        this.filter1 = { 'Year': moment().format('YYYY'),'Reviewer':''};

    }

    ngOnInit() {
        this.getReviewUsersByYear();
        this.GetRatingReport();
        this.getReviewersByYear();
        this.GetRatingReportByReviewer();    
    }


    ngAfterViewInit() {

        $(".date").datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $(".dateYear").datetimepicker({
            format: 'YYYY',
            maxDate:moment().set({hour:0,minute:0,second:0,millisecond:0})
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });


        this.filter.ReviewUser = ""
    }

    public changeYear(event){
        this.filter.Year = event.srcElement.value;
    }

    public changeYear1(event){
        this.filter1.Year = event.srcElement.value;
    }


    public clearFilter() {
        this.filter = { 'Year': moment().format('YYYY'),'ReviewUser':this.userDetail.SiteUserId};
    }

    public clearFilter1() {
        this.filter1 = { 'Year': moment().format('YYYY'),'Reviewer':''};
    }

    public GetRatingReport() {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/GetRatingReportSelf', {"UserId":this.filter.ReviewUser, "ReviewerId": this.userDetail.SiteUserId, "Year": this.filter.Year }).subscribe(
            data => {
                this.reportItems = data["RatingReport"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public GetRatingReportByReviewer() {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/GetRatingReportSelf', {"UserId":this.userDetail.SiteUserId, "ReviewerId": this.filter1.Reviewer, "Year": this.filter1.Year }).subscribe(
            data => {
                this.reportItemsByReviewer = data["RatingReport"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getReviewUsersByYear() {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/GetReviewUsersByYear', { "ReviewerId": this.userDetail.SiteUserId, "Year" : this.filter.Year }).subscribe(
            data => {
                this.reviewUsers = data["ReviewUsers"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getReviewersByYear() {
        this.showLoader = true;
        this._httpService.ajaxPost('Review/GetReviewersByYear', { "UserId": this.userDetail.SiteUserId, "Year" : this.filter.Year, "ReviewType": 1 }).subscribe(
            data => {
                this.reviewers = data["Reviewers"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ReviewReport/ratingReportSelf.component.ts
 **/